<template>
  <v-container>
    <v-row>
      <v-col cols="5">
        <form-bike mode="create" :data="form" @update="updateForm"></form-bike>
      </v-col>
      <v-col cols="7">
        <div class="map-wrap">
          <google-map :zoom="range.zoom" :paths="range.paths" :center="range.position"></google-map>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-row>
          <v-col cols="6">
            <v-btn @click="cancel" color="error" outlined="outlined" min-width="160" large="large">{{ $t('buttons.cancel') }}</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn @click="submit" color="secondary" min-width="160" large="large">{{ $t('buttons.confirm') }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMap from '@/components/GoogleMap'
import FormBike from '@/components/Bikes/Forms/Bike'

export default {
  components: { FormBike, GoogleMap },
  data () {
    return {
      form: {
        model: '',
        id: '',
        appVersion: null,
        certificate: null,
        productionDate: null,
        maintenance: null
      }
    }
  },
  computed: {
    ...mapGetters({
      stations: 'station/list',
      range: 'range/data'
    })
  },
  methods: {
    updateForm ({ field, value }) {
      this.form[field] = value
    },
    cancel () {
      this.backToBikes()
    },
    submit () {
      this.backToBikes()
    },
    backToBikes () {
      this.$router.push('/bikes')
    }
  }
}
</script>
